import { render, staticRenderFns } from "./SetSimulation.vue?vue&type=template&id=0d4b5ef7"
import script from "./SetSimulation.vue?vue&type=script&lang=js"
export * from "./SetSimulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports